var map = {
	"./alphab": 28,
	"./alphab.png": 28,
	"./paisley": 29,
	"./paisley.png": 29,
	"./payments": 30,
	"./payments.png": 30,
	"./polly-logo": 31,
	"./polly-logo.png": 31,
	"./sa-shop": 32,
	"./sa-shop.png": 32,
	"./ss-dashboard": 33,
	"./ss-dashboard.jpg": 33,
	"./sync-shop": 34,
	"./sync-shop.png": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;